import { ErrorService } from "../services/errorService.js";

/**
 * TEMPORARY: Issue #302 Monitoring Helper
 *
 * Reports empty parent objects detected in API responses to Sentry.
 * This file will be removed once Issue #302 is resolved.
 *
 * @param {Object} params - The reporting parameters
 * @param {Array} params.accountsWithEmptyParent - Accounts with empty parent objects
 * @param {Array} params.allAccounts - All accounts from API response
 * @param {string} params.callId - Unique call ID for tracking
 * @param {number} params.callTimestamp - Timestamp of the API call
 * @param {Object} params.responseHeaders - Response headers from the API
 */
export const reportEmptyParentToSentry = ({
    accountsWithEmptyParent,
    allAccounts,
    callId,
    callTimestamp,
    responseHeaders
}) => {
    if (!accountsWithEmptyParent || accountsWithEmptyParent.length === 0) {
        return;
    }

    console.error(`🔴 [${callId}] EMPTY PARENT DETECTED!`, accountsWithEmptyParent);

    // Report to Sentry immediately with raw API response
    ErrorService.handleError(new Error('[Issue #302] Empty parent detected at API response'), {
        level: 'warning',
        fingerprint: ['issue-302', 'empty-parent', 'api-response'],
        tags: {
            issue: '302',
            detection_point: 'api_response',
            affected_count: accountsWithEmptyParent.length,
            call_id: callId,
            // Correlation tags to link with NewEventPage error
            affected_account_id: accountsWithEmptyParent[0]?._id,
            user_id: accountsWithEmptyParent[0]?.owner
        },
        contexts: {
            apiResponse: {
                callId,
                callTimestamp,
                totalAccounts: allAccounts.length,
                affectedAccounts: accountsWithEmptyParent.map(acc => ({
                    id: acc._id,
                    name: acc.name,
                    handler: acc.handler,
                    parentValue: JSON.parse(JSON.stringify(acc.parent)),  // Serialize for Sentry
                    parentKeys: Object.keys(acc.parent)
                })),
                allAccounts: allAccounts.map(acc => ({
                    id: acc._id,
                    name: acc.name,
                    isSubAccount: acc.isSubAccount,
                    hasParent: !!acc.parent,
                    parentType: typeof acc.parent,
                    parentIsEmpty: acc.parent && typeof acc.parent === 'object' && Object.keys(acc.parent).length === 0
                })),
                responseHeaders
            }
        }
    });
};
